import axios from "axios";
import React, { useEffect, useState } from "react";
import apiClient from "../../../utils/apiclient";
import { data, useNavigate } from "react-router-dom";

const CompletedOneTimeOrders = (route) => {
  const [Data, setData] = useState([]);
const [page, setPage] = useState(0);
const [size] = useState(20);
const [totalPages, setTotalPages] = useState(0);
const [loading, setLoading] = useState(false);
const [freebieMap, setFreebieMap] = useState({});
  const ORDER_STATUSES = [
  "ordered",
  "delivered",
  "cancelled",
  "Refunded",
  "Rider is assigned",
  "on the way",
  "payment_initiated",
  "payment_cancelled",
  "delivered_Refunded",

];
  const navigate =useNavigate();
 const [search,Setsearch]=useState("")
const [statusMap, setStatusMap] = useState({});
const [refundMap, setRefundMap] = useState({});

  useEffect(() => {
  fetchOrders();
}, [page, search]);

const fetchOrders = async () => {
  try {
    setLoading(true);

    const response = await apiClient.get(
  `${route.route}?page=${page}&size=${size}&search=${search}`
);

    const pageData = response.data.content;

    setData(pageData);
    setTotalPages(response.data.totalPages);

    const map = {};
    const freebieStateMap = {};
    pageData.forEach((o) => {
      map[o.id] = {
        coins: o.refundedCoins || 0,
        cash: o.refundedCash || 0,
      };
      freebieStateMap[o.id] = o.freebieDelivered ?? false;
    });

    const statusInitMap = {};
    pageData.forEach((o) => {
      statusInitMap[o.id] = o.orderStatus;
    });

    setStatusMap(statusInitMap);
    setRefundMap(map);
    setFreebieMap(freebieStateMap);

  } catch (e) {
    console.error(e);
  } finally {
    setLoading(false);
  }
};
  const handleRefundChange = (orderId, field, value) => {
  setRefundMap((prev) => ({
    ...prev,
    [orderId]: {
      ...prev[orderId],
      [field]: value,
    },
  }));
};
const handleSaveStatus = async (orderId) => {
  const newStatus = statusMap[orderId];

  try {
    const body =
      newStatus === "Refunded" || newStatus === "delivered_Refunded"
        ? {
            coins: Number(refundMap[orderId]?.coins || 0),
            cash: Number(refundMap[orderId]?.cash || 0),
          }
        : {};

    await apiClient.put(
      `/updateOrderStatus/${orderId}/${newStatus}`,
      body
    );

    setData((prev) =>
      prev.map((order) =>
        order.id === orderId
          ? { ...order, orderStatus: newStatus }
          : order
      )
    );
  } catch (e) {
    console.error(e);
  }
};

const handleFreebieChange = (orderId, value) => {
  setFreebieMap((prev) => ({
    ...prev,
    [orderId]: value === "true",
  }));
};

const handleSaveFreebie = async (orderId) => {
  const newStatus = freebieMap[orderId] ?? false;

  try {
    await apiClient.post("/update-freebieDelivered", {
      orderType: "O",
      id: orderId,
      status: newStatus,
    });

    setData((prev) =>
      prev.map((order) =>
        order.id === orderId
          ? { ...order, freebieDelivered: newStatus }
          : order
      )
    );
  } catch (e) {
    console.error(e);
  }
};

const filteredData = Data.filter((el) => {
    if (search.trim() === "") {
      return true; 
    }
    return (
      el.name?.toLowerCase().includes(search.toLowerCase()) || 
      el.number?.toString().includes(search) ||
      el.email?.toLowerCase().includes(search.toLowerCase())
    );
  });
   const handleStatusChange = (orderId, newStatus) => {
    setStatusMap((prev) => ({
      ...prev,
      [orderId]: newStatus,
    }));
  };
    const handlechange=(e)=>{
        const value=e.target.value;
        Setsearch(value);
        console.log(value)
    }
    console.log("Data:", Data);
console.log("Length:", Data.length);
  return (
    <div className="w-full flex-1 flex flex-col min-h-0">
      <div className="flex justify-between items-center mb-2 flex-shrink-0 gap-3">
        <h2 className="text-base md:text-xl font-semibold text-gray-800 whitespace-nowrap">Completed One-Time Orders</h2>
        <input className="flex-1 border-2 py-1.5 px-3 md:py-2 md:px-4 text-sm md:text-base rounded-lg outline-none focus:border-blue-500 min-w-0"
          placeholder='Search...'
          onChange={handlechange}
          value={search}
        />
      </div>

    <div className="w-full flex-1 flex flex-col min-h-0">

  {loading && (
    <div className="absolute inset-0 bg-white/70 flex justify-center items-center z-10">
      <div className="text-lg font-semibold">
        Loading...
      </div>
    </div>
  )}{

<div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className='min-w-max w-full bg-white shadow-md border-collapse'>
  <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
    <tr>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Order Id</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Public Id</th>

      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Chef Id</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Items</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Delivery Instruction</th>

      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">OTP</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Non Discounted Price</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Price</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Coins</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Discount Value</th>

      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Order Status</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Freebie Delivered</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Customer Number</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Customer Name</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Restaurant Name</th>
      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Order Date</th>
       <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Start Time</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">End Time</th>
                  <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Order Items <br/><span className='p-2'> name </span><span className='p-2'> count </span><span className='p-2'> price </span><span className='p-2'> description </span></th>

      <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Rider name</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Rider number</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Created At</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Updated At</th>
    </tr>
  </thead>

  <tbody>
    {Data.map((data, index) => (
      <tr key={index} className="items-center justify-center border border-gray-300">
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
          {data.id}
        </td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.publicId}</td>

        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.chefid}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
          <div className="flex flex-col items-center">
            {data.orderItems.map((orderItems, idx) => (
              <div key={idx} className="flex gap-2">
                <span>{orderItems.name}</span>x
                <span>{orderItems.count}</span>=
                <span>{orderItems.price}</span>
              </div>
            ))}
          </div>
        </td>

        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.deliveryInstruction?data.deliveryInstruction:"no data"}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.otp}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.nonDiscountedPrice}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.price}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.coinsused}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.discountvalue}</td>
<td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
  {(() => {
    const currentStatus = statusMap[data.id] ?? data.orderStatus;

    console.log("Current Status:", data.id, currentStatus);

    return (
      <>
        <select
          className="border rounded px-2 py-1"
          value={currentStatus}
          onChange={(e) =>
            handleStatusChange(data.id, e.target.value)
          }
        >
          {ORDER_STATUSES.map((status) => (
            <option key={status} value={status}>
              {status.replace(/_/g, " ").toUpperCase()}
            </option>
          ))}
        </select>

        {currentStatus !== data.orderStatus && (
          <button
            onClick={() => handleSaveStatus(data.id)}
            className="bg-green-600 text-white px-2 py-1 rounded text-sm mt-2"
          >
            Save
          </button>
        )}

        {(currentStatus === "Refunded" ||
          currentStatus === "delivered_Refunded") && (
          <div className="flex gap-2 mt-2">
            <input
              type="number"
              placeholder="Coins"
              className="border px-2 py-1 rounded w-20"
              value={refundMap[data.id]?.coins || ""}
              onChange={(e) =>
                handleRefundChange(data.id, "coins", e.target.value)
              }
            />

            <input
              type="number"
              placeholder="Cash"
              className="border px-2 py-1 rounded w-20"
              value={refundMap[data.id]?.cash || ""}
              onChange={(e) =>
                handleRefundChange(data.id, "cash", e.target.value)
              }
            />
          </div>
        )}
      </>
    );
  })()}
</td>
  <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">
    <div className="flex items-center justify-center gap-2">
      <select
        className="border rounded px-2 py-1"
        value={String(freebieMap[data.id] ?? false)}
        onChange={(e) => handleFreebieChange(data.id, e.target.value)}
      >
        <option value="false">No</option>
        <option value="true">Yes</option>
      </select>

      {String(freebieMap[data.id] ?? false) !== String(data.freebieDelivered ?? false) && (
        <button
          onClick={() => handleSaveFreebie(data.id)}
          className="bg-indigo-600 hover:bg-indigo-700 text-white px-2 py-1 rounded text-sm font-medium"
        >
          Save Freebie
        </button>
      )}
    </div>
  </td>
  <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer hover:underline"
          onClick={() => navigate(`/userDetails/${data.number}`)}
        >
          {data.number}
        </td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.userdetails?.name}</td>

        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer hover:underline"
          onClick={() => navigate(`/restaurant/${data.restaurantid}`)}
        >
          {data.restaurantName}
        </td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.orderdate}</td>
         <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.startTime}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.endTime}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm flex flex-col justify-center text-center items-center">{data.orderItems.map((orderItems,idx)=>(
                <tr key={idx} className='flex '><td className="px-2 md:px-5 py-2 text-[10px] md:text-sm w-20">{orderItems.name}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm w-20">{orderItems.count}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm w-16">{orderItems.price}</td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm w-16">{orderItems.description?orderItems.description:"no data"}</td></tr>
              
              ))}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.riderDetails.name}</td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.riderDetails.number}</td>
                  <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.createdAt?data.createdAt.split("T")[1].split(".")[0]:"-"}</td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.updatedAt?data.updatedAt.split("T")[1].split(".")[0]:"-"}</td>
      </tr>
    ))}
  </tbody>
</table>
      </div>
}

 </div>  

  <div className="flex justify-center items-center gap-4 mt-0 pb-4 flex-shrink-0">
        <button
          disabled={page === 0 || loading}
          onClick={() => setPage((prev) => prev - 1)}
          className="px-6 py-2 bg-gray-800 text-white font-semibold rounded disabled:opacity-50 hover:bg-gray-700 transition-colors"
        >
          Previous
        </button>

        <span className="font-medium text-gray-700">
          Page {page + 1} of {totalPages}
        </span>

        <button
          disabled={page >= totalPages - 1 || loading}
          onClick={() => setPage((prev) => prev + 1)}
          className="px-6 py-2 bg-gray-800 text-white font-semibold rounded disabled:opacity-50 hover:bg-gray-700 transition-colors"
        >
          Next
        </button>
      </div>

 </div>);
};

export default CompletedOneTimeOrders;
